module.exports = __webpack_public_path__ + "static/1158507800.cca5fd6d.jpg";